import m from "../../geodata/es2015/stPierreMiquelonLow";
window.am4geodata_stPierreMiquelonLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/stPierreMiquelonLow.js
// module id = null
// module chunks = 